import type { FC, ReactNode } from 'react'
import type { PinnedStep } from '@/components/generals/pinned-steps'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { PageHero } from '@/components/generals/page-hero'
import { LogoTicker } from '@/components/generals/logo-ticker'
import { ClosingCta } from '@/components/generals/closing-cta'
import { PinnedSteps } from '@/components/generals/pinned-steps'
import { ScoutRing, SomePeopleGetIt } from '@/components/scouts/scout-sections'

import {
    BuildWindow,
    EarnWindow,
    IntroWindow,
    SCOUT_MOCK_NARROW_WIDTH,
    SCOUT_MOCK_WIDTH
} from '@/components/scouts/scout-windows'

import { routes } from '@/constants/site'

const STEPS: PinnedStep[] = [
    {
        label: 'Build',
        title: 'Build your collective',
        body: 'Invite designers you rate. Add a personalised comment to their profile. Let them know why you like their work',
        window: <BuildWindow />
    },
    {
        label: 'Intro',
        title: 'Companies request intros',
        body: 'Companies apply to meet designers in your collective. Know a company a designer could meet, bring them in too',
        window: <IntroWindow />
    },
    {
        label: 'Earn',
        title: 'Earn',
        body: "When a designer you scouted gets introduced, you get paid. We'll walk you through the details",
        window: <EarnWindow />
    }
]

const BecomeAScout: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Become a Scout'
                description='Help your network land their next job. Scout designers you believe in, introduce them to companies and earn when a placement lands.'
            />

            <PageHero
                title='Help your network land their next job'
                sub='Scout designers you believe in. Intro them to companies. Earn'
                titleClassName='max-w-[16ch]'
                subClassName='max-w-[40ch]'
                primary={{ label: 'Become a scout', href: routes.applyToScout }}
                secondary={{ label: 'See placements', href: routes.placements }}
                aside={<ScoutRing />}
            >
                <LogoTicker label='Sourced by our scouts for' className='enter mt-[clamp(48px,5vw,72px)]' />
            </PageHero>

            <SomePeopleGetIt />

            <PinnedSteps
                id='build-intro-earn'
                title='Build, intro, earn'
                kicker='Become a Scout'
                steps={STEPS}
                rail='left'
                hideTitle
                narrowBody
                mockWidth={SCOUT_MOCK_WIDTH}
                mockNarrowWidth={SCOUT_MOCK_NARROW_WIDTH}
                className='pb-[clamp(90px,9vw,140px)]'
            />

            <ClosingCta
                id='not-everyone'
                title='Not everyone gets to be a scout'
                line="If you have a community of designers you believe in and want to connect them with companies worth joining, let's chat"
                buttonLabel='Become a scout'
                href={routes.applyToScout}
            />
        </Layout>
    )
}

export default BecomeAScout
